<template>
  <div ref="satisfaction" class="customer-satisfaction">
    <div class="customer-satisfaction__text">
      <div class="customer-satisfaction__title">
        혜움 서비스는 <br />
        고객이 직접 증명합니다
      </div>
      <p class="customer-satisfaction__paragraph">
        이미 많은 고객들이 혜움을 추천하고 있습니다.<br />
        이는 넷플릭스(51), 구글(48)보다 높은 수치이며<br />
        관련 업계 대비 90점 이상 높은 수치입니다.<br /><br />
        <a
          href="http://www.sejungilbo.com/news/articleView.html?idxno=32351"
          target="_blank"
          class="customer-satisfaction__link"
          >관련기사 자세히 보기</a
        >
      </p>
    </div>
    <div class="customer-satisfaction__chart">
      <img src="~assets/images/customer-review/nps-chart.png" alt="" />
      <div class="customer-satisfaction__chart-description">
        *2022년 2분기 고객 순 추천지수(NPS) 조사 결과
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    startAnimation: false
  }),
  computed: {
    ...mapState(['scrollPositionY'])
  },
  watch: {
    scrollPositionY: {
      deep: true,
      handler() {
        if (
          this.scrollPositionY.bottom >
          this.chartAnimationStartPostion - 48
        ) {
          this.startAnimation = true
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.chartAnimationStartPostion =
        this.$refs.satisfaction.offsetTop + this.$refs.satisfaction.clientHeight
    })
  }
}
</script>

<style lang="scss">
.customer-satisfaction {
  max-width: 820px;
  margin: 0 auto;
  padding: 104px 1rem;
  @include clearfix;

  @include av-mq(lap-and-up) {
    padding: 184px 1rem 136px;
  }

  &__title {
    margin-bottom: 1rem;
    font-size: 24px;
    line-height: 1.48;
    color: #323438;

    @include av-mq(lap-and-up) {
      margin-bottom: 1rem;
      font-size: 32px;
      line-height: 1.48;
    }
  }

  &__paragraph {
    max-width: 400px;
    margin-bottom: 2rem;
    opacity: 0.8;
    font-size: 16px;
    line-height: 1.81;
    color: #323438;
    word-break: keep-all;

    @include av-mq(lap-and-up) {
      font-size: 18px;
      line-height: 1.48;
    }
  }

  &__text {
    @include av-mq(lap-and-up) {
      float: left;
      width: calc(100% - 400px);
    }
  }

  &__chart {
    max-width: 400px;
    margin: 0 auto;
    @include av-mq(lap-and-up) {
      float: left;
    }

    img {
      max-width: 100%;
    }

    &-description {
      padding-top: 2rem;
      text-align: right;
      color: #8f8d8d;
      font-size: 14px;
      font-weight: bold;
    }
  }

  &__link {
    font-size: 14px;
    line-height: 1.48;
    color: #85878c;
    word-break: keep-all;
  }
}
</style>
